import { app } from '../../bootstrap/core';
import { loginState } from './login.state';
import { loginComponent } from './login.component';
import loginFormPartial from './partials/loginForm.tpl.html';

app.config(loginState);
app.component(loginComponent.name, loginComponent);
app.constant('loginFormPartial', loginFormPartial);
